import { Firebase, organizationId } from './../util';

import store from '../store';

export function OrganizationsRef(){
  return Firebase.firestore().collection(`organizations`);
}

export function OrganizationRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`);
}

export function PublicUsersRef(){
  return Firebase.firestore().collection('users');
}

export function UsersRef(){
  return OrganizationRef().collection('users');
}

export function TeamsRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`).collection('teams');
}

export function SprintHistoryRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`).collection('sprintHistory');
}
export function CurrentSprintsRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`).collection('currentSprints');
}

export function TalentEvaluationsRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`).collection('talentEvaluations');
}

export function FeedbackRef(){
  return Firebase.firestore().collection('feedback');
}

export function DealsRef(){
  return Firebase.firestore().doc(`organizations/${organizationId()}`).collection('deals');
}



// WEBPACK FOOTER //
// ./src/util/refs.js